import { render } from "./SurveyQuestion8.vue?vue&type=template&id=2527d53e"
import script from "./SurveyQuestion8.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion8.vue?vue&type=script&lang=js"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__